module.exports = __webpack_public_path__ + "3f7fa24b4c68fa6ca3302c2bb085d0a4.pdf";